export const Countries = {
"China": 1402422200,
"India": 1361624001,
"United States": 329600913,
"Indonesia": 266911900,
"Pakistan": 220892331,
"Brazil": 211455864,
"Nigeria": 206139587,
"Bangladesh": 168523822,
"Russia": 146745098,
"Mexico": 126577691,
"Japan": 125950000,
"Philippines": 108558425,
"Egypt": 100312601,
"Ethiopia": 98665000,
"Vietnam": 96208984,
"DR Congo": 89561404,
"Iran": 83404725,
"Turkey": 83154997,
"Germany": 83149300,
"France": 67075000,
"Thailand": 66499067,
"United Kingdom": 66435550,
"Italy": 60238522,
"South Africa": 58775022,
"Tanzania": 55890747,
"Myanmar": 54339766,
"South Korea": 51780579,
"Colombia": 49395678,
"Kenya": 47564296,
"Spain": 47100396,
"Argentina": 44938712,
"Algeria": 43000000,
"Sudan": 42464285,
"Ukraine": 41858119,
"Uganda": 40299300,
"Iraq": 39127900,
"Poland": 38379000,
"Canada": 38010675,
"Morocco": 35882739,
"Saudi Arabia": 34218169,
"Uzbekistan": 34153934,
"Malaysia": 32764760,
"Afghanistan": 32225560,
"Venezuela": 32219521,
"Peru": 32131400,
"Angola": 31127674,
"Ghana": 30280811,
"Mozambique": 30066648,
"Nepal": 29996478,
"Yemen": 29825968,
"Cameroon": 26545864,
"Madagascar": 26251309,
"Ivory Coast": 25823071,
"Australia": 25693109,
"North Korea": 25450000,
"Taiwan": 23604265,
"Niger": 22314743,
"Sri Lanka": 21803000,
"Burkina Faso": 20870060,
"Mali": 20250833,
"Romania": 19405156,
"Malawi": 19129952,
"Chile": 19107216,
"Kazakhstan": 18691104,
"Zambia": 17885422,
"Syria": 17500657,
"Ecuador": 17474976,
"Netherlands": 17460481,
"Guatemala": 16604026,
"Chad": 16244513,
"Senegal": 16209125,
"Somalia": 15893219,
"Cambodia": 15288489,
"Zimbabwe": 15159624,
"South Sudan": 12778250,
"Rwanda": 12374397,
"Guinea": 12218357,
"Benin": 11733059,
"Tunisia": 11722038,
"Haiti": 11577779,
"Belgium": 11524454,
"Bolivia": 11469896,
"Cuba": 11209628,
"Burundi": 10953317,
"Greece": 10724599,
"Czech Republic": 10693939,
"Jordan": 10668944,
"Dominican Republic": 10358320,
"Sweden": 10338368,
"Portugal": 10276617,
"Azerbaijan": 10067108,
"United Arab Emirates": 9890400,
"Hungary": 9772756,
"Belarus": 9408400,
"Israel": 9192150,
"Honduras": 9158345,
"Tajikistan": 9127000,
"Papua New Guinea": 8935000,
"Austria": 8902600,
"Switzerland": 8603899,
"Sierra Leone": 7901454,
"Togo": 7538000,
"Hong Kong": 7500700,
"Paraguay": 7252672,
"Laos": 7123205,
"Serbia": 6963764,
"Bulgaria": 6951482,
"Libya": 6871287,
"Lebanon": 6825442,
"Kyrgyzstan": 6533500,
"El Salvador": 6486201,
"Nicaragua": 6460411,
"Turkmenistan": 6031187,
"Denmark": 5822763,
"Singapore": 5703600,
"Congo": 5518092,
"Finland": 5528390,
"Central African Republic": 5496011,
"Slovakia": 5457873,
"Norway": 5367580,
"Costa Rica": 5058007,
"New Zealand": 4981816,
"Palestine": 4976684,
"Ireland": 4921500,
"Oman": 4664790,
"Liberia": 4475353,
"Kuwait": 4420110,
"Panama": 4218808,
"Mauritania": 4077347,
"Croatia": 4076246,
"Georgia": 3723464,
"Uruguay": 3518552,
"Eritrea": 3497117,
"Mongolia": 3315016,
"Bosnia and Herzegovina": 3301000,
"Armenia": 2957500,
"Albania": 2845955,
"Lithuania": 2793471,
"Qatar": 2747282,
"Jamaica": 2726667,
"Moldova": 2681735,
"Namibia": 2458936,
"The Gambia": 2347706,
"Botswana": 2338851,
"Gabon": 2172579,
"Slovenia": 2094060,
"North Macedonia": 2077132,
"Lesotho": 2007201,
"Latvia": 1906800,
"Kosovo": 1795666,
"Guinea-Bissau": 1604528,
"Bahrain": 1543300,
"East Timor": 1387149,
"Trinidad and Tobago": 1363985,
"Equatorial Guinea": 1358276,
"Estonia": 1328360,
"Mauritius": 1265985,
"Eswatini": 1093238,
"Djibouti": 1078373,
"Fiji": 884887,
"Cyprus": 875900,
"Comoros": 873724,
"Guyana": 782766,
"Bhutan": 741672,
"Solomon Islands": 680806,
"Macau": 679600,
"Montenegro": 622359,
"Luxembourg": 626108,
"Suriname": 581372,
"Cape Verde": 550483,
"Malta": 493559,
"Brunei": 442400,
"Belize": 408487,
"Bahamas": 385340,
"Maldives": 374775,
"Iceland": 366130,
"Vanuatu": 304500,
"Barbados": 287025,
"São Tomé and Príncipe": 201784,
"Samoa": 200874,
"Saint Lucia": 178696,
"Kiribati": 120100,
"Grenada": 112003,
"Saint Vincent and the Grenadines": 110608,
"F.S. Micronesia": 104468,
"Tonga": 100651,
"Seychelles": 97625,
"Antigua and Barbuda": 96453,
"Andorra": 77543,
"Dominica": 71808,
"Marshall Islands": 55500,
"Saint Kitts and Nevis": 52823,
"Liechtenstein": 38749,
"Monaco": 38100,
"San Marino": 33553,
"Palau": 17900,
"Nauru": 11000,
"Tuvalu": 10200
};